import Popper from 'popper.js'

const state = {
  el: null,
  caption: '',
  cancelText: '',
  confirmText: '',
  callback: null,
  popper: null,
  _popperInstance: null,
  messageHtml: false,
  open: false
}

const mutations = {
  show(state) {
    state.open = true
  }
}

const actions = {
  show({state, dispatch, commit}, {el, caption, cancelText, confirmText, callback, element, messageHtml}) {
    state.el = el
    state.caption = caption
    state.cancelText = cancelText
    state.confirmText = confirmText
    state.callback = callback
    state.messageHtml = messageHtml
    state._popperInstance = new Popper(element, state.popper, {
      modifiers: {
        placement: 'bottom.start'
      }
    })
    commit('show')
    state._popperInstance.scheduleUpdate()
  },
  close({state}) {
    if (state._popperInstance) {
      state._popperInstance.destroy()
    }
    state.open = false
  },
  assignPopper({state}, {popper}) {
    state.popper = popper
  }
}

export default {
  namespaced: true,
  state,
  // getters,
  mutations,
  actions
}
